import React from 'react'
import Input from '../DMGComponents/Input'
import { sendAdHocVerificationMail, checkAdHocVerificationCode, getAdHocEntry, acceptAdHocPrivacyPolicy } from '../fetchData';
import Button from '../DMGComponents/Button'
import toast, { Toaster } from 'react-hot-toast';
import FileExLogo from '../components/FileExLogo';
import { getParameterByName} from '../utils/helperFunctions';
import PrivacyPolicy from '../components/PrivacyPolicy';
import AdHocAreaContent from '../components/AdHocAreaContent';
import UnauthenticatedHeader from '../components/UnauthenticatedHeader';
import Spinner from '../components/Spinner';

class AdHoc extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth,
            emailAddress: '',
            isLoading: false,
            validationError: '',
            codeSent: false,
            sendCodeButtonDisabled: false,
            verificationCode: '',
            verifyCodeButtonDisabled: true,
            otpValidationError: '',
            adHocToken: '',
            privacyPolicyAccepted: false,
            verificationDone: false,
            adHocArea: { adHocId: '', areaId: '', emailAddress: '', privacyPolicyAccepted: '', fileSpace: 0 }
        }

        this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
        this.verificationCodeKeyDown = this.verificationCodeKeyDown.bind(this);
        this.checkVerificationCode = this.checkVerificationCode.bind(this);
        this.verificationCodeChanged = this.verificationCodeChanged.bind(this);
    } 

    componentDidMount() {
        let urlAdHocIdParam = getParameterByName("id");
        if (urlAdHocIdParam != null) {
            getAdHocEntry(urlAdHocIdParam)
                .then((responseData) => {
                    if (responseData.isError) {
                        this.setState({
                            validationError: responseData.data,
                        })
                    }
                    else {
                        this.setState({
                            adHocArea: {
                                adHocId: responseData.data.adHocId, areaId: responseData.data.areaId, emailAddress: responseData.data.emailAddress,
                                privacyPolicyAccepted: responseData.data.privacyPolicyAccepted, fileSpace: responseData.data.fileSpace
                            },
                            privacyPolicyAccepted: responseData.data.privacyPolicyAccepted,
                        })
                    }
                }).catch((err) => {
                    console.error("Error", err);
                    toast.error("Error validating link.")
                })
        }
    }

    verificationCodeKeyDown = (e) => {
        if (e.key === 'Enter' && !this.state.verifyCodeButtonDisabled) {
            this.checkVerificationCode();
        }
    }

    verificationCodeChanged = (value) => {
        if (value && value.trim().length > 0) {
            value = value.trim();
            this.setState({ verificationCode: value })
            if (String(value).match(/^[0-9]{6}$/)) {
                this.setState({ verifyCodeButtonDisabled: false })
            }
            else {
                this.setState({ verifyCodeButtonDisabled: true })
            }
        }
    }

    checkVerificationCode = () => {
        this.setState({ otpValidationError: '' })
        checkAdHocVerificationCode(this.state.adHocArea.adHocId, this.state.verificationCode)
            .then((responseData) => {
                if (responseData.isError) {
                    this.setState({
                        otpValidationError: responseData.data,
                    })
                }
                else {
                    this.setState({
                        adHocToken: responseData.data,
                        verificationDone: true
                    })
                }
            }).catch((err) => {
                console.error("Error", err);
                toast.error("Error checking verification code")
            })
    }

    enableSendCodeButton = (timeoutMs) => {
        setTimeout(() => {
            this.setState({
                sendCodeButtonDisabled: false,
            });
        }, timeoutMs)
    }

    sendVerificationEmail = () => {
        this.setState({
            sendCodeButtonDisabled: true,
        })
        sendAdHocVerificationMail(this.state.adHocArea.adHocId)
            .then(() => {
                this.setState({
                    codeSent: true,
                })
                this.enableSendCodeButton(10000);
            }).catch((err) => {
                this.enableSendCodeButton(10000);
                console.error("Error", err);
                toast.error("Error sending verification email.")
            })
    }
    
    setAreaAccessEntryTrue = () => {
        acceptAdHocPrivacyPolicy(this.state.adHocArea.adHocId, this.state.adHocToken)
            .then(() => {
                this.setState({
                    privacyPolicyAccepted: true,
                })
            }).catch((err) => {
                console.error("Error", err);
                toast.error("Error accepting privacy policy.")
            })
    }

    render() {
        return (
            <div>
                <UnauthenticatedHeader isUsaVersion={this.props.appSettings.isUsaVersion} />
                <FileExLogo />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Toaster />
                    {this.state.isLoading ?
                        <div style={{ flex: '1' }}>
                            <Spinner />
                        </div>
                        :
                        <React.Fragment>
                            {!this.state.verificationDone &&
                                <div>
                                    {this.state.validationError.length === 0 &&
                                        <React.Fragment>
                                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "12px" }}>
                                                <label style={{ marginBottom: "0" }}>To view the area you need to verify your email address.</label>
                                                <label>By clicking on "Send code" a code will be sent to your email address for verification.</label>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "row", marginTop: "12px" }}>
                                                <Input label="Email address" value={this.state.adHocArea.emailAddress} isDisabled={true} style={{ width: "100%" }} />
                                            </div>
                                        </React.Fragment>
                                    }
                                    <div>
                                        {this.state.validationError.length > 0 &&
                                            <label style={{ color: "#F50506", marginTop: "12px" }}>{this.state.validationError}</label>
                                        }
                                    </div>
                                    {this.state.validationError.length === 0 &&
                                        <div style={{ display: "flex", justifyContent: "center", float: "right", marginTop: "12px" }}>
                                            <Button type="hover-bottom-left" onClick={() => this.sendVerificationEmail()} disabled={this.state.sendCodeButtonDisabled} >Send code</Button>
                                        </div>
                                    }
                                    <div style={{ clear: "both" }} ></div>
                                    {this.state.codeSent &&
                                        <React.Fragment>
                                            <hr style={{ marginBottom: "12px" }} />
                                            <label>Please enter the 6-digit code sent to your email address below and click on "Verify code".</label>
                                            <Input label="Verification code" value={this.state.verificationCode} onClick={this.verificationCodeChanged} onKeyDown={this.verificationCodeKeyDown} />
                                            <div>
                                                {this.state.otpValidationError.length > 0 &&
                                                    <label style={{ color: "#F50506", marginTop: "12px" }}>{this.state.otpValidationError}</label>
                                                }
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", float: "right", marginTop: "12px" }}>
                                                <Button type="hover-bottom-left" onClick={() => this.checkVerificationCode()} disabled={this.state.verifyCodeButtonDisabled}>Verify code</Button>
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>
                            }
                            {this.state.verificationDone &&
                                <div style={{ flex: '1' }}>
                                    {this.state.privacyPolicyAccepted ?
                                        <AdHocAreaContent adHocToken={this.state.adHocToken} refreshAreaContent={refreshMethod => this.refreshAreaContent = refreshMethod} />
                                        :
                                        <PrivacyPolicy area={null} agreeToPrivacyPolicy={this.setAreaAccessEntryTrue} noDbWriteNeeded={true} />
                                    }
                                </div>
                            }
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}
export default AdHoc;